// Band+ promo screen (TV) — temporary stand-in for MagicBandTV.
// Pure passive art: base image + pulsing overlay. NOTHING here is
// focusable and nothing autofocuses, so remote focus stays on the
// BottomBar and the user navigates away exactly like any other screen.

const PULSE_SECONDS = 3;

const BCTV_STYLE = `
  .bctv-root {
    position: fixed; inset: 0;
    background: #000;
    overflow: hidden;
    pointer-events: none;
  }
  .bctv-img {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover;
    display: block;
  }
  .bctv-pulse {
    opacity: 0;
    animation: bctv-pulse ${PULSE_SECONDS}s ease-in-out infinite;
  }
  @keyframes bctv-pulse {
    0%   { opacity: 0; }
    50%  { opacity: 1; }
    100% { opacity: 0; }
  }
`;

export default function BeaconComingTV() {
  return (
    <div className="bctv-root">
      <style>{BCTV_STYLE}</style>
      <img className="bctv-img" src="/static/beacon_coming.jpg" alt="" />
      <img className="bctv-img bctv-pulse" src="/static/beacon_coming2.png" alt="" />
    </div>
  );
}
